export const stripHTML = (html: string, useSpaces = false): string => {
  const element = document.createElement('div');
  // append a break element to every new paragraph to preserve line breaks
  element.innerHTML = html.replace(/<p>/gm, '<br/><p>');
  const plain = `${element.innerText}`;
  element.remove();
  if (useSpaces === true) return plain.replace(/\n/gm, ' ');
  return plain;
};
